import api from './client'

// Portal público del cliente — seguimiento del pedido por token propio (sin login).
export const seguimientoApi = {
  obtener: (token) => api.get(`/publico/seguimiento/${token}`),
  reprogramar: (token, data) => api.post(`/publico/seguimiento/${token}/reprogramar`, data),
  instrucciones: (token, data) => api.post(`/publico/seguimiento/${token}/instrucciones`, data),
  rating: (token, data) => api.post(`/publico/seguimiento/${token}/rating`, data),
  contacto: (token, data) => api.post(`/publico/seguimiento/${token}/contacto`, data),
  reclamo: (token, data) => api.post(`/publico/seguimiento/${token}/reclamo`, data),
  encuesta: (token, data) => api.post(`/publico/seguimiento/${token}/encuesta`, data),
}

/** Encuesta de experiencia de compra (mail de las 48 h) — por token propio. */
export const encuestaCompraApi = {
  obtener: (token) => api.get(`/publico/encuestas/${token}`),
  responder: (token, data) => api.post(`/publico/encuestas/${token}/responder`, data),
  proximaSeleccion: (token, data) => api.post(`/publico/encuestas/${token}/proxima-seleccion`, data),
}

export const encuestaEventoApi = {
  obtener: (token) => api.get(`/publico/encuesta-evento/${token}`),
  responder: (token, data) => api.post(`/publico/encuesta-evento/${token}/responder`, data),
}
